import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
  IonModal,
  useIonModal,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React, { useState, useEffect } from 'react';

interface Client {
  id: string;
  company_name: string;
  supervisors?: any[];
}

interface ClientSelectModalProps {
  clients: Client[];
  onDismiss: (data?: Client | null) => void;
}

const ClientSelectModal: React.FC<ClientSelectModalProps> = ({ clients, onDismiss }) => {
  const [searchText, setSearchText] = useState('');
  const [filteredClients, setFilteredClients] = useState<Client[]>(clients);

  useEffect(() => {
    setFilteredClients(
      clients.filter(client =>
        client.company_name.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [searchText, clients]);

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Select Client</IonTitle>
          <IonButton
            slot="end"
            fill="clear"
            onClick={() => onDismiss(null)} // ❌ Cancel
          >
            <IonIcon icon={closeOutline} />
          </IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonSearchbar
          value={searchText}
          onIonInput={e => setSearchText(e.detail.value!)}
          placeholder="Search clients..."
        />
        <IonList>
          {filteredClients.map(client => (
            <IonItem
              key={client.id}
              button
              onClick={() => onDismiss(client)} // ✅ Select client
            >
              <IonLabel>{client.company_name}</IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </>
  );
};

export default ClientSelectModal;
